// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "respweb/static/styles/" + {"963":"mntv-app-respweb","9495":"mntv-vend-sm-webassets"}[chunkId] + "." + {"963":"f60025bd","9495":"0a5150d1"}[chunkId] + ".css";
};